
import Vue from "vue";
import {MessagesService } from "@/services/messages-service";
import { IMail } from "@/utils/mail";
import { downloadBlob } from "@/utils/blob";
import { MailSettingsService } from "@/services/mail-settings-service";

export default Vue.extend({
	data() {
		return {
			editMessage: false,
			mailData: {
				from: "",
				name: "",
				to: "",
				subject: "",
				body: "",
				attachments: [],
				isHTML: true,
				bcc: "",
				cc: ""
			} as IMail,
		};
	},
	props: {
		attachment: File,
	},
	computed: {
		input(): HTMLInputElement {
			return (this.$refs.input as any).inputElement as HTMLInputElement;
		}
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		async send() {
			let mailSettings = await MailSettingsService.getDefaultSettings();
			try {
				await MessagesService.sendMail(this.mailData, mailSettings);
				this.$wf.notify(
					this.$ct("success"),
					"success",
					3500,
					"exclamation-triangle"
				);
				this.$emit("cancel");
			} catch (e) {
				this.$wf.notify(
					this.$ct("error.500"),
					"danger",
					3500,
					"exclamation-triangle"
				);
			}
		},
		isAllowed(): Boolean {
			return true;
			//return AuthService.hasModule(83);
		},
		async downloadDocument() {
			downloadBlob(this.attachment, this.attachment.name);
		},
	},
	async mounted() {
		this.mailData.attachments = [this.attachment];
		let mailSettings = await MailSettingsService.getDefaultSettings();
		if (!this.mailData.from || this.mailData.from.match(/^\s*$/)) {
			this.mailData.from = mailSettings.EmailFrom || mailSettings.Email;
			this.mailData.name = mailSettings.EmailName;
		}
		this.mailData.subject = this.$ct("default-subject").toString();
		this.mailData.body = this.$ct("default-message").toString() + `\n${
			mailSettings.Signature
		}`;
	},
	components: {
		VueEditor: () => import("@/utils/vue-editor")
	},
	i18nEx: {
		componentPrefix: "components.reportengine.modal"
	}
});
